import { maturityQuestions as importedQuestions } from '@/constants/maturityQuestions';

// Transform questions for display with section renaming for results context
export const maturityQuestions = importedQuestions.map(q => ({
  ...q,
  section: q.section === 'Operational Excellence' ? 'Operational Maturity' : 'Strategic Maturity',
}));

// Helper to get selected text option for a question
export const getSelectedOption = (questionIndex: number, score: number): string => {
  if (questionIndex >= maturityQuestions.length || score < 1 || score > 5) {
    return 'No response';
  }
  return maturityQuestions[questionIndex].options[score - 1] || 'No response';
};

